import { api } from '../../../api';
import { getSearchUrl } from '../../../utils/purePayload';
import { GET_CATEGORIES_REQUEST, GET_CATEGORIES_RESPONSE } from './types';
const requestParams = {
  page_number: 1,
  page_size: '1000',
  sorting_option: 'title-asc',
  search_string: '',
  has_next_page: true,
};
export function getCategories() {
  const urlWithOutSearchString = `/menu/categories?page_number=${requestParams.page_number}&page_size=${requestParams.page_size}`;
  const URL = getSearchUrl(
    urlWithOutSearchString,
    requestParams.search_string,
    3
  );
  return function (dispatch) {
    dispatch({ type: GET_CATEGORIES_REQUEST });
    api
      .get(URL)
      .then((response) => {
        dispatch({ type: GET_CATEGORIES_RESPONSE, response: response.data });
      })
      .catch((error) => {
        // console.log(error);
      });
  };
}
